import { ShippingClaimReason } from "@redotech/cockroachdb-codegen/congodb/shipping-claim-reason";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const CARRIER_CLAIMS_GRAINS = ["day", "week", "month"] as const;
export const carrierClaimsGrainSchema = z.enum(CARRIER_CLAIMS_GRAINS);
export type CarrierClaimsGrain = z.infer<typeof carrierClaimsGrainSchema>;

export const CARRIER_CLAIMS_REQUESTED_BY = [
  "merchant",
  "proactive",
  "unknown",
] as const;
export const CARRIER_CLAIMS_TYPES = ["outbound", "return"] as const;
export const CARRIER_CLAIMS_ACCOUNT_KINDS = [
  "redo_account",
  "merchant_account",
] as const;
export const CARRIER_CLAIMS_TEAM_MODES = ["all", "except", "only"] as const;
export type CarrierClaimsTeamMode = (typeof CARRIER_CLAIMS_TEAM_MODES)[number];

export const CARRIER_CLAIMS_GROUP_BYS = [
  "carrier",
  "route",
  "merchant",
] as const;
export const carrierClaimsGroupBySchema = z.enum(CARRIER_CLAIMS_GROUP_BYS);
export type CarrierClaimsGroupBy = z.infer<typeof carrierClaimsGroupBySchema>;

export const CARRIER_CLAIMS_SNAPSHOT_GROUP_BYS = ["carrier", "route"] as const;
export const carrierClaimsSnapshotGroupBySchema = z.enum(
  CARRIER_CLAIMS_SNAPSHOT_GROUP_BYS,
);
export type CarrierClaimsSnapshotGroupBy = z.infer<
  typeof carrierClaimsSnapshotGroupBySchema
>;

const shippingClaimReasonSchema = createEnum(ShippingClaimReason, {
  enumName: "ShippingClaimReason",
});

export const carrierClaimsFilterSchema = z.object({
  startDate: z.date(),
  endDate: z.date(),
  carriers: z.array(z.string()).default([]),
  requestedBy: z.array(z.enum(CARRIER_CLAIMS_REQUESTED_BY)).default([]),
  types: z.array(z.enum(CARRIER_CLAIMS_TYPES)).default([]),
  reasons: z.array(shippingClaimReasonSchema).default([]),
  accountKinds: z.array(z.enum(CARRIER_CLAIMS_ACCOUNT_KINDS)).default([]),
  teamMode: z.enum(CARRIER_CLAIMS_TEAM_MODES).default("all"),
  teamIds: z.array(z.string()).default([]),
});
export type CarrierClaimsFilter = z.infer<typeof carrierClaimsFilterSchema>;

export const carrierClaimsDimensionSchema = z.object({
  key: z.string(),
  label: z.string(),
});
export type CarrierClaimsDimension = z.infer<
  typeof carrierClaimsDimensionSchema
>;
